export default function logoLink() {
  const init = () => {
    const logoLinkUrl = document.body?.dataset?.logoLinkUrl;
    if (!logoLinkUrl) return;

    const logoElement = document.querySelector('.venn-logo-link');
    if (!logoElement) return;

    const parentLink = logoElement.closest('a');
    if (parentLink) {
      parentLink.href = logoLinkUrl;
      return;
    }

    if (logoElement.tagName === 'A') {
      logoElement.href = logoLinkUrl;
      return;
    }

    const wrapper = document.createElement('a');
    wrapper.href = logoLinkUrl;
    wrapper.setAttribute('aria-label', 'Logo link');
    wrapper.style.display = 'inline-block';

    logoElement.parentNode.insertBefore(wrapper, logoElement);
    wrapper.appendChild(logoElement);
  };

  init();
}